<ng-container *ngIf="sizeData">
	<div class="size-choose-container">
		<div class="choose-size-txt">
			{{sizeData.displayName?sizeData.displayName:'Choose Size'}}
		</div>
		<p class="keyfeature"  *ngIf="!selectedCustomSizeLabel">{{keyfeature}}</p>
		<p class="keyfeature"  *ngIf="selectedCustomSizeLabel">{{selectedCustomSizeLabel}}</p>
		<div class="size_box_cont">
			<ng-container *ngFor="let size of sizeOption; let i = index">
				<div class="size-box {{deltaIndex==i?'active':''}}" (click)="selectSize(i, size)">
					<div class="size-content">
						{{size.label}}
					</div>
				</div>
			</ng-container>
			<!-- <div class="img-wrapper custom_cont" *ngIf="isFabricProduct&&customSizeData" (click)="openCustomSize()"> -->
			<div class="img-wrapper custom_cont {{selectedCustomSizeLabel?'custom_size_active':''}}"  *ngIf="customSizeDataEnabled" (click)="openCustomSize()">
				<button class="{{isFabricProduct?'fabric_custom':''}}">
					<span class="text_custom">CUSTOM</span>
					<span class="material-symbols-outlined icon_text">
						tune
					</span>
				</button>
			</div>

			<div class="more_option_button" (click)="openSizeguide()">
				<span><span *ngIf="!isFabricProduct">Size</span> Guide</span>
				<span class="material-symbols-outlined">
					info
				</span>
			</div>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="customSizeDataEnabled" >
	<fb-choose-custom-size [customSizeDataPassOne]="customSizeData" *ngIf="openCustomSIzeModal"
		(continueCustomSizeClick)="continueCustomSize()"
		(closeCustomSizePopup)="closeCustomSize()"></fb-choose-custom-size>
</ng-container>
<ng-container *ngIf="sizeData">
	<fb-choose-size-more-option [sizeDataPassOne]="sizeData" *ngIf="openSizeGuide" (closeSizeGuide)="close()">
	</fb-choose-size-more-option>
</ng-container>
